import "./Contact.css";
import React from "react";
import { useState } from "react";
import { Helmet } from "react-helmet";

function Contact() {
  const [submit, setSubmit] = useState(false);
  const [formData, setFormData] = useState({
    "entry.2005620554": "", //name
    "entry.1997263290": "", //mobile
    "entry.1963146997": "", //order place
    "entry.1305394875": "", //email
    "entry.839337160": "", //product detail
  });

  const handleInputData = (input) => (e) => {
    const { value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmit(true);

    let url = `https://docs.google.com/forms/u/0/d/e/1FAIpQLSfUqmqquHhvUyhyIIC4FLz6wxvprP7uUMK7dGZ4D_D34vM2Gg/formResponse?entry.2005620554=${formData["entry.2005620554"]}&entry.1997263290=${formData["entry.1997263290"]}&entry.1963146997=${formData["entry.1963146997"]}&entry.1305394875=${formData["entry.1305394875"]}&entry.839337160=${formData["entry.839337160"]}`;

    let res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    console.log(res);
  }
  return (
    <>
      <Helmet>
        <title>Creative Balloons, All Inflatables | Contact Us</title>
        <meta
          name="description"
          content="Creative Balloons is a trusted manufacturer and supplier of
          premium quality Inflatable Characters, Advertising Balloons, and
          other products. Sky balloon, Inflatables, Costumes, Bouncy Castles, Arches, Danglers, templets and Etc."
        />
      </Helmet>
      <section className="Contact">
        <div className="contact-innnersec">
          <div className="Textpan1 center disNone">
            <h1>Inflatable Balloons</h1>
            <p>
              Creative Inflatables Balloons is a trusted manufacturer and
              supplier of premium quality Inflatable Characters other products.
            </p>
            <button type="button" onclick="Readmore">
              Click Me!
            </button>
          </div>

          <div className="contactUs">
            <div className="row">
              <div className="col adress">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke="none"
                    fill="#89d8e3"
                    d="M13.6177 21.367C13.1841 21.773 12.6044 22 12.0011 22C11.3978 22 10.8182 21.773 10.3845 21.367C6.41302 17.626 1.09076 13.4469 3.68627 7.37966C5.08963 4.09916 8.45834 2 12.0011 2C15.5439 2 18.9126 4.09916 20.316 7.37966C22.9082 13.4393 17.599 17.6389 13.6177 21.367Z"
                    stroke-width="1.5"
                  />
                  <path
                    stroke="none"
                    fill="white"
                    d="M15.5 11C15.5 12.933 13.933 14.5 12 14.5C10.067 14.5 8.5 12.933 8.5 11C8.5 9.067 10.067 7.5 12 7.5C13.933 7.5 15.5 9.067 15.5 11Z"
                    stroke-width="1.5"
                  />
                </svg>

                <div className="type1-textpan">
                  <h5>OUR MAIN OFFICE</h5>
                  <p className="center">
                    Plot No: 5, Lakshminagar, Near Pillor No: 63, Mehdipatnam,
                    Hyderabad-500081.{" "}
                  </p>
                </div>
              </div>

              <div className="col phn-num">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="#89d8e3"
                  class="injected-svg"
                  data-src="/icons/call-stroke-rounded.svg"
                  role="img"
                  color="#6e90e2"
                >
                  <path
                    d="M3.77762 11.9424C2.8296 10.2893 2.37185 8.93948 2.09584 7.57121C1.68762 5.54758 2.62181 3.57081 4.16938 2.30947C4.82345 1.77638 5.57323 1.95852 5.96 2.6524L6.83318 4.21891C7.52529 5.46057 7.87134 6.08139 7.8027 6.73959C7.73407 7.39779 7.26737 7.93386 6.33397 9.00601L3.77762 11.9424ZM3.77762 11.9424C5.69651 15.2883 8.70784 18.3013 12.0576 20.2224M12.0576 20.2224C13.7107 21.1704 15.0605 21.6282 16.4288 21.9042C18.4524 22.3124 20.4292 21.3782 21.6905 19.8306C22.2236 19.1766 22.0415 18.4268 21.3476 18.04L19.7811 17.1668C18.5394 16.4747 17.9186 16.1287 17.2604 16.1973C16.6022 16.2659 16.0661 16.7326 14.994 17.666L12.0576 20.2224Z"
                    stroke="#6e90e2"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <div className="type1-textpan">
                  <h5>PHONE NUMBER</h5>
                  <p className="center">9246167123</p>
                </div>
              </div>

              <div className="col fax">
                <div className="type1-textpan">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14.1706 20.8905C18.3536 20.6125 21.6856 17.2332 21.9598 12.9909C22.0134 12.1607 22.0134 11.3009 21.9598 10.4707C21.6856 6.22838 18.3536 2.84913 14.1706 2.57107C12.7435 2.47621 11.2536 2.47641 9.8294 2.57107C5.64639 2.84913 2.31441 6.22838 2.04024 10.4707C1.98659 11.3009 1.98659 12.1607 2.04024 12.9909C2.1401 14.536 2.82343 15.9666 3.62791 17.1746C4.09501 18.0203 3.78674 19.0758 3.30021 19.9978C2.94941 20.6626 2.77401 20.995 2.91484 21.2351C3.05568 21.4752 3.37026 21.4829 3.99943 21.4982C5.24367 21.5285 6.08268 21.1757 6.74868 20.6846C7.1264 20.4061 7.31527 20.2668 7.44544 20.2508C7.5756 20.2348 7.83177 20.3403 8.34401 20.5513C8.8044 20.7409 9.33896 20.8579 9.8294 20.8905C11.2536 20.9852 12.7435 20.9854 14.1706 20.8905Z"
                      stroke="#89d8e3"
                      stroke-width="1.5"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.9953 12H12.0042M15.9908 12H15.9998M7.99976 12H8.00873"
                      stroke="#89d8e3"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <h5>
                    <a
                      href="https://api.whatsapp.com/send?phone=9246167123"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Whatsapp.com
                    </a>
                  </h5>
                  <a
                    href="https://api.whatsapp.com/send?phone=9246167123"
                    target="_blank"
                    rel="noreferrer"
                    className="center"
                  >
                    {" "}
                    Text Us
                  </a>
                </div>
              </div>

              <div className="col e-mail">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  class="injected-svg"
                  data-src="/icons/mail-add-02-stroke-rounded.svg"
                  role="img"
                  color="#89d8e3"
                >
                  <path
                    d="M7 7.5L9.94202 9.23943C11.6572 10.2535 12.3428 10.2535 14.058 9.23943L17 7.5"
                    stroke="#89d8e3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M11.5 19.5C11.5 19.5 10.0691 19.4878 9.09883 19.4634C5.95033 19.3843 4.37608 19.3448 3.24496 18.2094C2.11383 17.0739 2.08114 15.5412 2.01577 12.4756C1.99475 11.4899 1.99474 10.5101 2.01576 9.52438C2.08114 6.45885 2.11382 4.92608 3.24495 3.79065C4.37608 2.65521 5.95033 2.61566 9.09882 2.53656C11.0393 2.48781 12.9607 2.48781 14.9012 2.53657C18.0497 2.61568 19.6239 2.65523 20.7551 3.79066C21.8862 4.92609 21.9189 6.45886 21.9842 9.52439C21.9918 9.88124 21.9967 10.4995 21.9988 11"
                    stroke="#89d8e3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M14 17.5H22M18 21.5L18 13.5"
                    stroke="#89d8e3"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>

                <div className="type1-textpan">
                  <h5>
                    <a href="mailto:info@creativeinflatables.in">SEND E-MAIL</a>
                  </h5>
                  <a
                    href="mailto:info@creativeinflatables.in"
                    className="center"
                  >
                    info@creativeinflatable.in
                  </a>
                </div>
              </div>
            </div>

            <div className="ContactAt">
              <div className="contactDeatil">
                <div className="formheader"></div>
                <div className="formcontact">
                  {submit ? (
                    <div className="afterForm">
                      <h1>Thank you!</h1>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M2 12.5C2 11.3954 2.89543 10.5 4 10.5C5.65685 10.5 7 11.8431 7 13.5V17.5C7 19.1569 5.65685 20.5 4 20.5C2.89543 20.5 2 19.6046 2 18.5V12.5Z"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.4787 7.80626L15.2124 8.66634C14.9942 9.37111 14.8851 9.72349 14.969 10.0018C15.0369 10.2269 15.1859 10.421 15.389 10.5487C15.64 10.7065 16.0197 10.7065 16.7791 10.7065H17.1831C19.7532 10.7065 21.0382 10.7065 21.6452 11.4673C21.7145 11.5542 21.7762 11.6467 21.8296 11.7437C22.2965 12.5921 21.7657 13.7351 20.704 16.0211C19.7297 18.1189 19.2425 19.1678 18.338 19.7852C18.2505 19.8449 18.1605 19.9013 18.0683 19.9541C17.116 20.5 15.9362 20.5 13.5764 20.5H13.0646C10.2057 20.5 8.77628 20.5 7.88814 19.6395C7 18.7789 7 17.3939 7 14.6239V13.6503C7 12.1946 7 11.4668 7.25834 10.8006C7.51668 10.1344 8.01135 9.58664 9.00069 8.49112L13.0921 3.96056C13.1947 3.84694 13.246 3.79012 13.2913 3.75075C13.7135 3.38328 14.3652 3.42464 14.7344 3.84235C14.774 3.8871 14.8172 3.94991 14.9036 4.07554C15.0388 4.27205 15.1064 4.37031 15.1654 4.46765C15.6928 5.33913 15.8524 6.37436 15.6108 7.35715C15.5838 7.46692 15.5488 7.5801 15.4787 7.80626Z"
                          stroke="#ffffff"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <h3>We will get back to you soon</h3>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} target="_self">
                      <div className="conSecRow">
                        <h2 className="mainHeading">Contact Us</h2>
                        <div className="conSecRow1">
                          <div className="conForm">
                            <div className="ContactUsForm ">
                              <fieldset>
                                <input
                                  required
                                  className="regular"
                                  type="text"
                                  placeholder="Your Name.."
                                  name="entry.2005620554"
                                  onChange={handleInputData("entry.2005620554")}
                                  value={formData["entry.2005620554"]}
                                />
                              </fieldset>
                              <fieldset>
                                <input
                                  required
                                  className="regular"
                                  type="number"
                                  placeholder="Your Number.."
                                  name="entry.1997263290"
                                  onChange={handleInputData("entry.1997263290")}
                                  value={formData["entry.1997263290"]}
                                />
                              </fieldset>
                              <fieldset>
                                <input
                                  required
                                  className="regular"
                                  type="email"
                                  placeholder="Your Email"
                                  name="entry.1305394875"
                                  onChange={handleInputData("entry.1305394875")}
                                  value={formData["entry.1305394875"]}
                                />
                              </fieldset>

                              <fieldset>
                                <input
                                  required
                                  className="regular"
                                  type="text"
                                  placeholder="Your Order Place.."
                                  name="entry.1963146997"
                                  onChange={handleInputData("entry.1963146997")}
                                  value={formData["entry.1963146997"]}
                                />
                              </fieldset>
                              <fieldset>
                                <textarea
                                  className="detail"
                                  name="entry.1839337160"
                                  rows="3"
                                  cols="10"
                                  placeholder="Enter More Detail:"
                                  onChange={handleInputData("entry.839337160")}
                                  value={formData["entry.839337160"]}
                                ></textarea>
                              </fieldset>
                              <div className="formBtn center">
                                <button type="submit">Connect with us</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="map">
            <iframe
              title="location"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7615.0025146660455!2d78.429433!3d17.387716!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb96fd409901c9%3A0x1b2dce908c89969f!2sLakshmi%20Nagar%2C%20Khader%20Bagh%2C%20Indira%20Nagar%2C%20Mehdipatnam%2C%20Hyderabad%2C%20Telangana%20500008%2C%20India!5e0!3m2!1sen!2sus!4v1706696105226!5m2!1sen!2sus"
            ></iframe>
            <div className="map-Textpan">
              <h3>Direction Towrads Over Company</h3>
              <p className="center">Easy to find us through this map</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Contact;
